import React from "react"
import { TableContainer, TableHead, TableBody, TableRow } from "@mui/material"
import { StyledTable, StyledHeaderCell, StyledBodyCell, StyledFooterCell } from "../../components/styled/StyledTableComponents"
import { formatPackagingsByBrandAndType } from "../../utils/packagingExecutions"
import { packagingNature, packagingCardOrder } from "../../utils/packaging"

// cell = { real, theoretical }
// returns "" if both 0, otherwise "real / theo" in DONE, else "theo"
const formatCell = (cell = {}, statusDone) => {
  const real = Math.ceil(cell.real || 0)
  const theo = Math.ceil(cell.theoretical || 0)

  if (!real && !theo) return ""
  return statusDone ? `${real} / ${theo}` : theo
}

const packagingLabelByType = Object.fromEntries(packagingNature.map(t => [t.value, t.label]))

const PackagingByBrandAndTypeTable = ({ packagings, brands, statusDone = false }) => {
  const {
    packagingTypePerBrand,
    brandTotals,
    typeTotals,
    total,
    activeType,
    visibleBrands
  } = formatPackagingsByBrandAndType(packagings, brands, packagingCardOrder, statusDone)

  return (
    <TableContainer>
      <StyledTable>
        <TableHead>
          <TableRow>
            <StyledHeaderCell sx={{ width: "18.5%" }}>
              {statusDone ? "Barquettes réalisées / prévues" : "Barquettes prévues"}
            </StyledHeaderCell>
            {packagingCardOrder.map(type => (
              <StyledHeaderCell key={type} active={activeType === type} sx={{ width: "22%" }}>
                {packagingLabelByType[type] || type}
              </StyledHeaderCell>
            ))}
            <StyledHeaderCell  active={activeType === "total"} sx={{ width: "15.5%" }}>
              Total
            </StyledHeaderCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {visibleBrands.map((brand, idx) => {
            const name = brand.name
            return (
              <TableRow key={"brand-" + name}>
                <StyledBodyCell leftEdge={true} lastBodyRow={idx === visibleBrands.length - 1}>
                  {brand.image
                    ? <img src={brand.image} alt={name + "-logo"} style={{ width: 32, height: 32, display: "block" }} />
                    : name}
                </StyledBodyCell>

                {packagingCardOrder.map(type => {
                  const cell = packagingTypePerBrand[name][type] || { real: 0, theoretical: 0 }
                  return (
                    <StyledBodyCell key={name + "-" + type}  active={activeType === type} lastBodyRow={idx === visibleBrands.length - 1}>
                      <div>{formatCell(cell, statusDone)}</div>
                    </StyledBodyCell>
                  )
                })}

                {(() => {
                  const t = brandTotals[name] || { real: 0, theoretical: 0 }
                  return (
                    <StyledBodyCell key={"total-" + name} active={activeType === "total"} rightEdge={true} lastBodyRow={idx === visibleBrands.length - 1}>
                      {formatCell(t, statusDone)}
                    </StyledBodyCell>
                  )
                })()}
              </TableRow>
            )
          })}

          <TableRow>
            <StyledFooterCell align="left">Total</StyledFooterCell>
            {packagingCardOrder.map(type => {
              const t = typeTotals[type] || { real: 0, theoretical: 0 }
              return (
                <StyledFooterCell key={"tot-" + type} active={activeType === type}>
                  {formatCell(t, statusDone)}
                </StyledFooterCell>
              )
            })}
            <StyledFooterCell active={activeType === "total"}>
              {formatCell(total, statusDone)}
            </StyledFooterCell>
          </TableRow>
        </TableBody>
      </StyledTable>
    </TableContainer>
  )
}

export default PackagingByBrandAndTypeTable